import React, { useState } from 'react'
import { supabase } from '../lib/supabase'
import { C } from '../theme'
import vsLogo from '../assets/vs-logo.png'

export default function Login() {
  const [benutzername, setBenutzername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    const { data: benutzer, error: lookupErr } = await supabase
      .from('benutzer')
      .select('email')
      .eq('benutzername', benutzername.trim().toLowerCase())
      .single()

    if (lookupErr || !benutzer) {
      setError('Benutzername nicht gefunden.')
      setLoading(false)
      return
    }

    const { error: authErr } = await supabase.auth.signInWithPassword({ email: benutzer.email, password })
    if (authErr) setError('Falsches Passwort.')
    setLoading(false)
  }

  return (
    <div style={styles.container}>
      <img src={vsLogo} alt="" aria-hidden="true" style={styles.watermark} />
      <div style={styles.card}>
        <img src={vsLogo} alt="VS Automobilzentrum" style={{ width: 240, display: 'block', margin: '0 auto 6px' }} />
        <div style={styles.goldLine} />
        <p style={styles.subtitle}>Werkstatt-Board · Mitarbeiter-Anmeldung</p>
        <form onSubmit={handleLogin}>
          <div style={styles.field}>
            <label style={styles.label}>Benutzername</label>
            <input
              style={styles.input}
              type="text"
              value={benutzername}
              onChange={e => setBenutzername(e.target.value)}
              required
              placeholder="benutzername"
              autoCapitalize="off"
              autoComplete="username"
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Passwort</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>
        <p style={styles.warning}>
          Dieses System ist ausschließlich für autorisierte Mitarbeiter der
          VS Automobilzentrum bestimmt. Unbefugter Zugriff ist gemäß{' '}
          <strong>§ 202a StGB</strong> strafbar und wird verfolgt.
        </p>
      </div>
      <p style={styles.footer}>© 2026 VS Automobilzentrum</p>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: `radial-gradient(ellipse at 50% 40%, #16314e 0%, ${C.dark} 70%)`,
    position: 'relative',
    overflow: 'hidden',
  },
  watermark: {
    position: 'absolute', top: '50%', left: '50%',
    transform: 'translate(-50%, -50%) rotate(-6deg)',
    width: '85%', maxWidth: 1000,
    opacity: 0.05, filter: 'invert(1)',
    pointerEvents: 'none', userSelect: 'none',
  },
  card: {
    background: 'rgba(255,255,255,0.97)',
    borderRadius: 16,
    padding: '36px 44px',
    width: 360,
    boxShadow: `0 8px 50px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,192,0,0.25)`,
    position: 'relative',
    zIndex: 1,
  },
  goldLine: {
    width: 56, height: 4, background: C.primary, borderRadius: 2,
    margin: '0 auto 14px',
  },
  subtitle: {
    color: C.textMuted,
    textAlign: 'center',
    marginBottom: 26,
    fontSize: 13,
  },
  field: { marginBottom: 16 },
  label: { display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6, color: '#333' },
  input: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: 8,
    fontSize: 14,
    boxSizing: 'border-box',
    outline: 'none',
  },
  error: { color: '#dc2626', fontSize: 13, marginBottom: 12 },
  button: {
    width: '100%',
    padding: '12px',
    background: C.primary,
    color: C.onPrimary,
    border: 'none',
    borderRadius: 8,
    fontSize: 15,
    fontWeight: 800,
    cursor: 'pointer',
    marginTop: 8,
  },
  warning: {
    marginTop: 20,
    padding: '12px 14px',
    background: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: 8,
    fontSize: 11,
    color: '#6b7280',
    textAlign: 'center',
    lineHeight: 1.6,
  },
  footer: {
    position: 'relative',
    zIndex: 1,
    marginTop: 20,
    fontSize: 11,
    color: 'rgba(255,255,255,0.3)',
    textAlign: 'center',
  },
}
